import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../../components/finalForms/libs/data/ValidationTypes";


const initState = {
    statusCategoryId:'',
    statusName: '',
    
  }

export const projectStatusTestFormData = {
    name: " Project Status Test Form",
    initialState: initState,
    section: [
        {
            sectionId: "projectStatus",
            title: "Project Status",
            row: {},
            style: {
                sectionStyle: "col-lg-12 col-md-1",
            },
            wrapperTemplate: <div className="form-card row"></div>,
            fields: [
                {
                    id: "statusCategoryId",
                    label: "Status Category",
                    Field_Name: "status category name",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "statusCategoryId",
                    fieldSetting: {
                      placeholder: "Please Select Status Category",
                      allowSpace: true,
                      options: [],
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                      containerCss: "col-lg-6 col-md-6 validation-left-0",
                    },
          
                },
                {
                    id: "statusName",
                    label: "Status Name",
                    Field_Name: " status name",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "statusName",
                    fieldSetting: {
                        placeholder: "Please Enter Status Name",
                        allowSpace: true,
                        isDisable: false,
                        maxLength: 50,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-12 mb-1 validation-left-0",
                    },
                },
                
            ],
            
        }
    ]
}